import { render, staticRenderFns } from "./HbPage.vue?vue&type=template&id=8efd1fe8&"
import script from "./HbPage.vue?vue&type=script&lang=js&"
export * from "./HbPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports